import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import App from "./App";
import "./index.css";

ReactDOM.render(
  <GoogleOAuthProvider clientId="47297364853-l3915m4liqjm0b4bi75gu4hqt2fqe6vl.apps.googleusercontent.com">
    <Router>
      <App />
    </Router>
  </GoogleOAuthProvider>,
  document.getElementById("root")
);
